module.exports = __webpack_public_path__ + "static/media/fan.0a08fcf4.svg";